export default "__VITE_ASSET__DZSQT9zT__"